<template>
  <v-container
    fluid
    class="grey lighten-4 fill-height"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
        class="text-center"
      >
        <h1>Rescue Inreach</h1>
        <h3>כניסה למערכת</h3>

        <v-card
          flat
          color="transparent"
        >
          <v-card-text>
            <div class="firebaseui-auth-outer-container">
              <div id="firebaseui-auth-container"></div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "auth",
  data() {
    return {};
  },
  computed: {
    user() {
      return this.$store.getters["user/user"];
    },
    isShown() {
      return true;
    }
  },
  methods: {},
  components: {},
  created() {},
  mounted() {
    let firebaseui = require("firebaseui");
    let uiConfig = {
      signInFlow: "popup",
      signInOptions: [
        {
          provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          scopes: ["profile", "email"]
        },
        {
          provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
          defaultCountry: "IL",
          recaptchaParameters: {
            type: "image", // 'audio'
            size: "invisible", // 'invisible' or 'compact'
            badge: "bottomleft" //' bottomright' or 'inline' applies to invisible.
          },
          scopes: []
        }
      ],
      callbacks: {
        signInSuccessWithAuthResult: () => {
          // let user = authResult.user;
          // let isNewUser = authResult.additionalUserInfo.isNewUser;
          return false;
        }
      }
    };
    let ui = firebaseui.auth.AuthUI.getInstance();
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth());
    }

    ui.start("#firebaseui-auth-container", uiConfig);
  }
};
</script>

<style scoped lang="scss">
@import "~firebaseui/dist/firebaseui.css";
</style>